{
  "data": {
    "isLoggedIn": true,
    "dateReceivedByVa": false,
    "incomeNetWorthDateRange": {
      "from": "2023-07-01",
      "to": "2024-01-01"
    },
    "veteranFullName": {
      "first": "John",
      "last": "Doe"
    },
    "otherVeteranFullName": {
      "first": "Jane",
      "last": "Doe"
    },
    "otherVeteranSocialSecurityNumber": "987654321",
    "claimantFullName": {
      "first": "Jane",
      "last": "Doe"
    },
    "claimantSocialSecurityNumber": "321654987",
    "claimantType": "SPOUSE",
    "email": "test.user@example.com",
    "claimantPhone": "555-867-5309",
    "view:isAddingUnassociatedIncomes": true,
    "unassociatedIncomes": [
      {
        "recipientRelationship": "SPOUSE",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "incomeType": "SOCIAL_SECURITY",
        "grossMonthlyIncome": 2500,
        "payer": "Business name"
      }
    ],
    "view:isAddingAssociatedIncomes": true,
    "associatedIncomes": [
      {
        "recipientRelationship": "SPOUSE",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "incomeType": "INTEREST",
        "grossMonthlyIncome": 500,
        "accountValue": 50000,
        "payer": "Financial name"
      }
    ],
    "view:isAddingOwnedAssets": true,
    "ownedAssets": [
      {
        "recipientRelationship": "SPOUSE",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "grossMonthlyIncome": 2500,
        "ownedPortionValue": 100000,
        "assetType": "BUSINESS",
        "view:addFormQuestion": true,
        "uploadedDocuments": {
          "name": "supporting-form.pdf"
        }
      },
      {
        "recipientRelationship": "CHILD",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "grossMonthlyIncome": 2500,
        "ownedPortionValue": 100000,
        "assetType": "FARM",
        "view:addFormQuestion": false
      }
    ],
    "view:isAddingRoyalties": true,
    "royaltiesAndOtherProperties": [
      {
        "recipientRelationship": "SPOUSE",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "canBeSold": true,
        "fairMarketValue": 25000,
        "grossMonthlyIncome": 1200,
        "incomeGenerationMethod": "INTELLECTUAL_PROPERTY"
      }
    ],
    "view:isAddingAssetTransfers": true,
    "assetTransfers": [
      {
        "originalOwnerRelationship": "SPOUSE",
        "transferMethod": "SOLD",
        "assetType": "Real Estate Property",
        "newOwnerName": { "first": "Alice", "last": "Johnson" },
        "newOwnerRelationship": "Friend",
        "saleReportedToIrs": true,
        "transferDate": "2023-05-15",
        "assetTransferredUnderFairMarketValue": false,
        "fairMarketValue": 250000.0,
        "saleValue": 240000.0,
        "capitalGainValue": 10000.0
      }
    ],
    "view:isAddingTrusts": true,
    "trusts": [
      {
        "establishedDate": "2020-03-15",
        "marketValueAtEstablishment": 100000.0,
        "trustType": "REVOCABLE",
        "addedFundsAfterEstablishment": true,
        "addedFundsDate": "2021-05-10",
        "addedFundsAmount": 5000.0,
        "receivingIncomeFromTrust": true,
        "annualReceivedIncome": 12000.0,
        "trustUsedForMedicalExpenses": false,
        "monthlyMedicalReimbursementAmount": 0.0,
        "trustEstablishedForVeteransChild": false,
        "haveAuthorityOrControlOfTrust": true,
        "view:addFormQuestion": true,
        "uploadedDocuments": [
          {
            "name": "supporting-form.pdf"
          }
        ]
      }
    ],
    "view:isAddingAnnuities": true,
    "annuities": [
      {
        "establishedDate": "2018-06-15",
        "marketValueAtEstablishment": 50000.75,
        "addedFundsAfterEstablishment": true,
        "addedFundsDate": "2020-09-22",
        "addedFundsAmount": 10000.25,
        "revocable": false,
        "receivingIncomeFromAnnuity": true,
        "annualReceivedIncome": 12000.0,
        "canBeLiquidated": true,
        "surrenderValue": 45000.5
      }
    ],
    "view:isAddingUnreportedAssets": true,
    "unreportedAssets": [
      {
        "assetOwnerRelationship": "SPOUSE",
        "ownedPortionValue": 500000.0,
        "assetType": "Investment Portfolio",
        "assetLocation": "Global Investments LLC, Portfolio ID #987654321"
      }
    ],
    "view:isAddingDiscontinuedIncomes": true,
    "discontinuedIncomes": [
      {
        "recipientRelationship": "SPOUSE",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "payer": "Social Security Administration",
        "incomeType": "WAGES",
        "incomeFrequency": "RECURRING",
        "incomeLastReceivedDate": "2023-05-15",
        "grossAnnualAmount": 18000.0
      }
    ],
    "view:isAddingIncomeReceiptWaivers": true,
    "incomeReceiptWaivers": [
      {
        "recipientRelationship": "SPOUSE",
        "recipientName": { "first": "Jane", "last": "Smith" },
        "payer": "Social Security Administration",
        "expectedIncome": 2000.0,
        "view:paymentsWillResume": true,
        "paymentResumeDate": "2027-06-01",
        "waivedGrossMonthlyIncome": 1800.0
      }
    ],
    "statementOfTruthSignature": "Jane Doe",
    "statementOfTruthCertified": true
  }
}
